// ==============================|| SELECT OVERRIDES ||============================== //

export default function Select(theme) {
    return {
        MuiSelect: {
            styleOverrides: {
                select: {},
            }
        }
    };
}
